export default __webpack_public_path__ + "static/MBMB-Photo-01-2326393c5e2a56b223cf13e27b19b2e7.mp4";